import { Component } from '@angular/core';

// TODO: Style/align button correctly & implement logic what should happen on click

@Component({
  selector: 'avano-button-bar-help',
  templateUrl: './avano-button-bar-help.component.html',
  styleUrls: ['./avano-button-bar-help.component.scss']
})
export class AvanoButtonBarHelpComponent {
  constructor() {}
}
